import { ClassProvider, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OregLibComponent } from './oreg-lib.component';
import { environment } from './environment';
import { SearchLayoutComponent } from './features/search/search-layout/search-layout.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SearchResultModule } from './shared/components/search-result/search-result.module';
import { SearchBarComponent } from './features/search/search-bar/search-bar.component';
import { CreateLayoutComponent } from './features/create/create-layout/create-layout.component';
import { CreateCompanyComponent } from './features/create/create-company/create-company.component';
import { CreateAddressComponent } from './features/create/create-address/create-address.component';
import { CreateWorksiteComponent } from './features/create/create-worksite/create-worksite.component';
import {
  ButtonModule,
  CheckboxesModule,
  DropdownModule,
  IconModule,
  TextareaModule,
  TextInputModule,
  TextInputPhoneModule,
  TooltipModule,
} from '@vinnova/ui';
import { IsValidBisnodeStatusPipeModule } from './shared/pipes/bisnode-status/bisnode-status.pipe.module';
import { IsValidLegalFormPipeModule } from './shared/pipes/valid-legal-form/valid-legal-form.pipe.module';
import { TranslocoModule } from '@ngneat/transloco';
import { AccountLayoutComponent } from './features/account/account-layout/account-layout.component';
import { AccountListComponent } from './features/account/account-list/account-list.component';
import { TranslatedCountryPipe } from './shared/pipes/translated-country.pipe';
import { AccountFormComponent } from './features/account/account-form/account-form.component';

@NgModule({
  declarations: [
    OregLibComponent,
    SearchLayoutComponent,
    SearchBarComponent,
    CreateLayoutComponent,
    CreateWorksiteComponent,
    CreateCompanyComponent,
    CreateAddressComponent,
    AccountLayoutComponent,
    AccountListComponent,
    AccountFormComponent,
  ],
  exports: [OregLibComponent, AccountLayoutComponent, AccountFormComponent],
  imports: [
    CommonModule,
    TooltipModule,
    IsValidBisnodeStatusPipeModule,
    IsValidLegalFormPipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SearchResultModule,
    TextInputModule,
    ButtonModule,
    DropdownModule,
    TextareaModule,
    CheckboxesModule,
    IconModule,
    TranslocoModule,
    TextInputPhoneModule,
    TranslatedCountryPipe,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class OregLibModule {
  public static forRoot(
    env,
    BankAccountClient: ClassProvider,
  ): ModuleWithProviders<OregLibModule> {
    return {
      ngModule: OregLibModule,
      providers: [{ provide: environment, useValue: env }, BankAccountClient],
    };
  }
}
